import React, { useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import AuthService from '../../../business-api/AuthService'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    nomeCurtoCliente,
} from '../../../business-rules/String/nomeCurto'

import {
    informouObjetivos,
} from '../cadastro-form/CadastroServiceObjetivos'

import {
    informouConsideracoesFinais,
} from '../consideracoesFinais-form/ConsideracoesFinaisService'

import {
    calculaMaiorPeriodoGraficoIdadesCenarios,
    calculaMaiorPeriodoGraficoIdadesEstudos,
    inicializaEstudo,
    processaCalculoEstudo
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    obtemPagina,
    paginas,
    reportLinhasSemGrafico,
    reportLinhasComGrafico,
} from './EstudoReportService'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
//    tituloClienteConjuge,
} from '../cliente-form/ClienteService'

import {
    processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge
} from '../estudo-form/EstudoServiceProtecaoSugeridaClienteConjuge'

import {
    EstudoFormCenarios
} from '../estudo-parametros/EstudoFormCenarios'

import {
    possuiCotacaoSeguroVidaApenasComparacaoPreco,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import EstudoReportPrimeiraReuniaoClienteConfiguracao from './EstudoReportPrimeiraReuniaoClienteConfiguracao'

import EstudoReportConferenciaDados from '../estudo-report/EstudoReportConferenciaDados'

import EstudoFormObjetivos from '../estudo-form/EstudoFormObjetivos'

import MapaFinanceiroFormGrafico from '../mapaFinanceiro-form/MapaFinanceiroFormGrafico'

import AnalisePatrimonialChart from '../estudo-chart/AnalisePatrimonialChart'

import GestaoPatrimonialFormResumoPatrimonial from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonial'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios'

import EstudoFormGarantiasRecursosFinanceirosDetalhado from '../estudo-form/EstudoFormGarantiasRecursosFinanceirosDetalhado'

import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'

import EstudoFormGarantiasReceitaMensalDetalhada from '../estudo-form/EstudoFormGarantiasReceitaMensalDetalhada'

import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'

import EstudoFormDespesasDespesaMensalDetalhada from '../estudo-form/EstudoFormDespesasDespesaMensalDetalhada'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'

import SimulacaoFinanceiraReportAporteRetiradaMensal from '../simulacaoFinanceira-form/SimulacaoFinanceiraReportAporteRetiradaMensal'

import SimulacaoFinanceiraReportAporteRetiradaAnual from '../simulacaoFinanceira-form/SimulacaoFinanceiraReportAporteRetiradaAnual'

import DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart'

import ComparacaoCenariosEstudosChart from '../estudo-chart/ComparacaoCenariosEstudosChart'

import CarteiraInvestimentosChart from '../estudo-chart/CarteiraInvestimentosChart'

import EstudoFormResumoSeguroVidaCotacao from '../estudo-form/EstudoFormResumoSeguroVidaCotacao'

import EstudoFormTabelaEvolucaoValorResgate from '../estudo-form/EstudoFormTabelaEvolucaoValorResgate'

import EstudoFormTabelaEvolucaoCS from '../estudo-form/EstudoFormTabelaEvolucaoCS'

import EstudoFormTabelaEvolucaoCancelamentoApolice from '../estudo-form/EstudoFormTabelaEvolucaoCancelamentoApolice'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

import AnaliseInvestimentoVersusSeguroVidaInteiraChart from '../estudo-chart/AnaliseInvestimentoVersusSeguroVidaInteiraChart'

import AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart from '../estudo-chart/AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart'

import EstudoFormComparacaoCenariosEstudos from '../estudo-form/EstudoFormComparacaoCenariosEstudos'

import EstudoFormProtecaoSugerida from '../estudo-form/EstudoFormProtecaoSugerida'

import EstudoFormSucessaoVitalicia from '../estudo-form/EstudoFormSucessaoVitalicia'

import EstudoFormComposicaoInventario from '../estudo-form/EstudoFormComposicaoInventario'

import EstudoFormConsideracoesFinais from '../estudo-form/EstudoFormConsideracoesFinais'

import SimulacaoFinanceiraFormEvolucaoReservaFinanceira from '../simulacaoFinanceira-form/SimulacaoFinanceiraFormEvolucaoReservaFinanceira'

import EstudoReportFormatoReport from './EstudoReportFormatoReport'

import EstudoReportContainer from './EstudoReportContainer'

import EstudoReportPage from './EstudoReportPage'

import EstudoReportPageCapa from './EstudoReportPageCapa'

import EstudoReportCapaPadrao from './EstudoReportCapaPadrao'

//import EstudoReportPrimeiraReuniaoInputsCliente from './EstudoReportPrimeiraReuniaoInputsCliente'

import EstudoReportDisclaimer from './EstudoReportDisclaimer'

import './EstudoReport.css'



const EstudoReportPrimeiraReuniaoCliente = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars, linhaFormList }) => {

    let pagina = useRef(0)

    pagina.current = 0



    const estudo = useRef(null)

    useSingleton(() => {
        
        estudo.current = inicializaEstudo(/*vars.jsonConfiguracao*/)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)
    })

    const report = true
    
    processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true/*false*/,
        HARDCODE.origemCalculoEstudoPrimeiraReuniaoReport, /*true*/false, vars.jsonConfiguracao, false)

    const estudoReportPrimeiraReuniaoTextoAbertura =
        vars.jsonConfiguracao && vars.jsonConfiguracao.estudoReportPrimeiraReuniaoTextoAbertura
            ?
                vars.jsonConfiguracao.estudoReportPrimeiraReuniaoTextoAbertura
            :
                MESSAGE().estudoReportPrimeiraReuniaoTextoAbertura



    const ProtecaoSugerida = ( { values, handleSubmitAutomatico, estudo } ) => { // replicado em EstudoReport

        processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge(values, handleSubmitAutomatico, estudo, vars.jsonConfiguracao, true)

        return (
            
            <>
                <EstudoFormProtecaoSugerida
                    variaveisGlobais={variaveisGlobais} 
                    values={values}
                    estudo={estudo}
                    vars={vars}
                    titulo={tituloCliente(values)}
                    idClienteConjuge={HARDCODE.idFamiliarCliente}
                    report={report}
                />
                {dadosCompletosConjuge(values) &&
                ((
                    values.protecaoSugeridaCliente && values.protecaoSugeridaConjuge &&
                    values.protecaoSugeridaCliente.length + values.protecaoSugeridaConjuge.length < 10
                ) ||
                //values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ||
                values.modoApresentacao) && (
                    <div
                        className='mt-15'
                    >
                        <EstudoFormProtecaoSugerida
                            variaveisGlobais={variaveisGlobais} 
                            values={values}
                            estudo={estudo}
                            vars={vars}
                            titulo={tituloConjuge(values)}
                            idClienteConjuge={HARDCODE.idFamiliarConjuge}
                            report={report}
                        />
                    </div>
                )}
            </>
        )
    }
       
    

    return (
        
        <>
            <EstudoFormCenarios
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
            />

            {!AuthService.obterAcessoCliente(variaveisGlobais) && (
                <EstudoReportFormatoReport
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                />
            )}

            {!AuthService.obterAcessoCliente(variaveisGlobais) && (
                <EstudoReportPrimeiraReuniaoClienteConfiguracao
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    linhaTipoLicenca={vars.linhaTipoLicenca}
                    linhaFormList={linhaFormList}
                />
            )}

            <EstudoReportContainer
                values={values}
                naoPermitirImprimir={values.formatoReport === HARDCODE.idFormatoReportApresentacao}
                conteudo={
                    <>
                        <EstudoReportPageCapa
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            conteudo={
                                <EstudoReportCapaPadrao
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            }
                        />

                        <EstudoReportPage
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            cabecalho={LABEL.conferenciaDados}
                            conteudo={
                                <>
                                    <div
                                        className='text-12'
                                        dangerouslySetInnerHTML={
                                            { __html:
                                                estudoReportPrimeiraReuniaoTextoAbertura
                                                    .replace('$nomeCurtoCliente$', nomeCurtoCliente(values))
                                                        .replace('$codigoAgente$',
                                                            vars.jsonUsuario.codigoAgente)
                                            }
                                        }
                                    />

                                    <br/>
                                    <br/>

                                    {/*
                                    <EstudoReportPrimeiraReuniaoInputsCliente
                                        values={values}
                                    />
                                    */}
                                    <EstudoReportConferenciaDados
                                        values={values}
                                        report={true}
                                        vars={vars}
                                        somenteClienteConjugeFamiliares={false}
                                        somenteClienteConjugeFamiliaresTaxas={false}
                                        incluirObjetivos={false}
                                    />
                                </>
                            }
                            pagina={obtemPagina(pagina)}
                        />

                        {/*values.objetivosPrincipaisPreocupacoes &&
                        values.objetivosPrincipaisPreocupacoes !== HARDCODE.richTextEditorVazio && (
                            <EstudoReportPage
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.objetivos}
                                conteudo={
                                    <EstudoFormObjetivos
                                        values={values}
                                        report={true}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )*/}
                        {informouObjetivos(values) && (
                            <>
                                {values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => (
                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={nvl(item.tituloPagina, LABEL.objetivosPrincipaisPreocupacoesPFCMLP)}
                                            conteudo={
                                                <EstudoFormObjetivos
                                                    values={values}
                                                    report={true}
                                                    indPagina={ind}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    )
                                ))}
                            </>
                        )}

                        {values.incluirMapaFinanceiroRelatorioCliente && (
                            <EstudoReportPage
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.mapaFinanceiro}
                                conteudo={
                                    <MapaFinanceiroFormGrafico
                                        values={values}
                                        report={true}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )}

                        {estudo.current.ativos > 0 && (
                            <>
                                <EstudoReportPage
                                    //key={ind}
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.analisePatrimonial}
                                    conteudo={
                                        <AnalisePatrimonialChart
                                            values={values}
                                            estudo={estudo}
                                            report={report}
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />

                                {estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length +
                                estudo.current.patrimonioImobilizadoDetalhadoNegocios.length +
                                estudo.current.recursosFinanceirosDetalhado.length +
                                (
                                    values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                                    estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length > 0
                                        ?
                                            estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length
                                        :
                                            0
                                ) <= 17
                                    ?
                                        <EstudoReportPage
                                            //key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.analisePatrimonial}
                                            conteudo={
                                                <GestaoPatrimonialFormResumoPatrimonial
                                                    values={values}
                                                    estudo={estudo}
                                                    report={report}
                                                    report1Pagina={true}
                                                    //indInicial={item.indInicial}
                                                    //indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    :
                                        <>
                                            {estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length > 0 && (
                                                paginas(estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis,
                                                values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                                    <EstudoReportPage
                                                        key={ind}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.patrimonioImobilizadoBensMoveisImoveis}
                                                        conteudo={
                                                            <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                                popup={false}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                ))
                                            )}

                                            {estudo.current.patrimonioImobilizadoDetalhadoNegocios.length > 0 && (
                                                paginas(estudo.current.patrimonioImobilizadoDetalhadoNegocios,
                                                values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina : '')?.map((item, ind) => (
                                                    <EstudoReportPage
                                                        key={ind}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.patrimonioImobilizadoNegocios}
                                                        conteudo={
                                                            <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                                popup={false}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                ))
                                            )}

                                            {estudo.current.recursosFinanceirosDetalhado.length > 0 && (
                                                paginas(estudo.current.recursosFinanceirosDetalhado,
                                                values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                HARDCODE.reportLinhasSemGraficoRetrato)?.map((item, ind) => (
                                                    <EstudoReportPage
                                                        key={ind}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={
                                                            LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                                                LABEL.instituicao + ' x ' +
                                                                    LABEL.tipoRecursoFinanceiro
                                                        }
                                                        conteudo={
                                                            <EstudoFormGarantiasRecursosFinanceirosDetalhado
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                                popup={false}
                                                                recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosDetalhado}
                                                                detalhadoTipoRecurso={false}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                ))
                                            )}

                                            {values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                                            estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length > 0 && (
                                                paginas(estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado,
                                                values.modoApresentacao ? HARDCODE.reportLinhasSemSaltoPagina :
                                                HARDCODE.reportLinhasSemGraficoRetrato)?.map((item, ind) => (
                                                    <EstudoReportPage
                                                        key={ind}
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={
                                                            LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                                                LABEL.tipoRecursoFinanceiro + ' x ' +
                                                                    LABEL.instituicao
                                                        }
                                                        conteudo={
                                                            <EstudoFormGarantiasRecursosFinanceirosDetalhado
                                                                values={values}
                                                                estudo={estudo}
                                                                report={report}
                                                                indInicial={item.indInicial}
                                                                indFinal={item.indFinal}
                                                                popup={false}
                                                                recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado}
                                                                detalhadoTipoRecurso={true}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                ))
                                            )}
                                        </>
                                }

                                {/*(
                                    paginas(
                                        estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length >
                                        estudo.current.patrimonioImobilizadoDetalhadoNegocios.length
                                            ?
                                                estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length >
                                                estudo.current.recursosFinanceirosDetalhado.length
                                                    ?
                                                        estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis
                                                    :
                                                        estudo.current.recursosFinanceirosDetalhado
                                            :
                                                estudo.current.patrimonioImobilizadoDetalhadoNegocios.length >
                                                estudo.current.recursosFinanceirosDetalhado.length
                                                    ?
                                                        estudo.current.patrimonioImobilizadoDetalhadoNegocios
                                                    :
                                                        estudo.current.recursosFinanceirosDetalhado
                                        , parseInt(reportLinhasSemGrafico(values) / 1.5),
                                        parseInt(reportLinhasComGrafico(values) / 1.5))?.map((item, ind) => (
                                            <EstudoReportPage
                                                key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.analisePatrimonial}
                                                conteudo={
                                                    <>
                                                        {ind === 0 && (
                                                            <AnalisePatrimonialChart
                                                                values={values}
                                                                estudo={estudo}
                                                                report={true}
                                                            />
                                                        )}

                                                        <GestaoPatrimonialFormResumoPatrimonial
                                                            values={values}
                                                            estudo={estudo}
                                                            report={true}
                                                            indInicial={item.indInicial}
                                                            indFinal={item.indFinal}
                                                        />
                                                    </>
                                                }
                                                pagina={obtemPagina(pagina)}
                                        />
                                        ))
                                    )
                                */}
                            </>
                        )}

                        {values.exibirCapacidadePoupancaRelatorio && (
                            <>
                                {paginas(estudo.current.receitaMensalDetalhada,
                                    reportLinhasSemGrafico(values), reportLinhasComGrafico(values))?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.receitaAnualLongoTempo}
                                            conteudo={
                                                <>
                                                    {ind === 0 && (
                                                        <ReceitaAnualChart
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            estudo={estudo}
                                                            vars={vars}
                                                            report={report}
                                                        />
                                                    )}

                                                    <EstudoFormGarantiasReceitaMensalDetalhada
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        estudo={estudo}
                                                        vars={vars}
                                                        report={report}
                                                        indInicial={item.indInicial}
                                                        indFinal={item.indFinal}
                                                    />
                                                </>
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                }

                                {paginas(estudo.current.despesaMensalDetalhada,
                                    reportLinhasSemGrafico(values), reportLinhasComGrafico(values))?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.despesaAnualLongoTempo}
                                            conteudo={
                                                <>
                                                    {ind === 0 && (
                                                        <DespesaAnualChart
                                                            values={values}
                                                            estudo={estudo}
                                                            vars={vars}
                                                            report={report}
                                                        />
                                                    )}

                                                    <EstudoFormDespesasDespesaMensalDetalhada
                                                        values={values}
                                                        estudo={estudo}
                                                        vars={vars}
                                                        report={report}
                                                        indInicial={item.indInicial}
                                                        indFinal={item.indFinal}
                                                    />
                                                </>
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                }

                                <EstudoReportPage
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.balancoReceitaDespesaAnual}
                                    conteudo={
                                        <BalancoReceitaXDespesaAnualChart
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            estudo={estudo}
                                            vars={vars}
                                            report={report}
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />
                            </>
                        )}

                        {values.exibirAportesRetiradasPlanejadosRelatorio &&
                        (
                            (values.aporteRetiradaMensal && values.aporteRetiradaMensal.length > 0) ||
                            (values.aporteRetiradaAnual && values.aporteRetiradaAnual.length > 0)
                        ) && (
                            <EstudoReportPage
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.aportesRetiradasPlanejados}
                                conteudo={
                                    <>
                                        {values.aporteRetiradaMensal && values.aporteRetiradaMensal.length > 0 && (
                                            <SimulacaoFinanceiraReportAporteRetiradaMensal
                                                values={values}
                                            />
                                        )}

                                        {values.aporteRetiradaAnual && values.aporteRetiradaAnual.length > 0 && (
                                            <SimulacaoFinanceiraReportAporteRetiradaAnual
                                                values={values}
                                            />
                                        )}
                                    </>
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )}

                        {!values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira &&
                        vars.idConfiguracao  !== '1cf12cd8-92d2-4039-9136-eb889b5b22be' && 
                        vars.idConfiguracao  !== '2a0c840b-747d-431f-b28c-69e3030f77ad' && (
                            <EstudoReportPage
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                conteudo={
                                    <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        estudo={estudo}
                                        report={true}
                                        popup={false}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )}

                        {vars.idConfiguracao !== '1cf12cd8-92d2-4039-9136-eb889b5b22be' &&
                        vars.idConfiguracao  !== '2a0c840b-747d-431f-b28c-69e3030f77ad' &&
                        !values.naoExibirEvolucaoReservaFinanceira &&
                        paginas(estudo.current.evolucaoReservaFinanceiraReport,
                        HARDCODE.reportLinhasSemGraficoSemTotaisComRodape)?.map((item, ind) => (
                            <EstudoReportPage
                                key={ind}
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.evolucaoReservaFinanceira}
                                conteudo={
                                    <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                                        values={values}
                                        estudo={estudo}
                                        report={true}
                                        popup={false}
                                        indInicial={item.indInicial}
                                        indFinal={item.indFinal}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        ))}

                        {existeTabelaEvolucaoValorResgate(values) &&
                        values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira && (
                            <EstudoReportPage
                                //key={index}
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.carteiraInvestimentos}
                                conteudo={
                                    <CarteiraInvestimentosChart
                                        values={values}
                                        estudo={estudo}
                                        report={true}
                                        popup={false}
                                        simulacaoFinanceira={true}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )}

                        {values.exibirProtecaoSugeridaRelatorio && vars.linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === 'S' && (
                            <>
                                <EstudoReportPage
                                    //key={index}
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.protecaoSugerida}
                                    conteudo={
                                        <ProtecaoSugerida
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />

                                {dadosCompletosConjuge(values) &&
                                !((
                                    values.protecaoSugeridaCliente && values.protecaoSugeridaConjuge &&
                                    values.protecaoSugeridaCliente.length + values.protecaoSugeridaConjuge.length < 10
                                ) ||
                                //values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ||
                                values.modoApresentacao) && (
                                    <EstudoReportPage
                                        //key={'conjuge' + index}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.protecaoSugerida}
                                        conteudo={
                                            <EstudoFormProtecaoSugerida
                                                variaveisGlobais={variaveisGlobais} 
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                                titulo={tituloConjuge(values)}
                                                idClienteConjuge={HARDCODE.idFamiliarConjuge}
                                                report={report}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                )}
                            </>
                        )}

                        {values.exibirSucessaoVitaliciaRelatorio && (
                            <>
                                <EstudoReportPage
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.sucessaoVitalicia}
                                    conteudo={
                                        <EstudoFormSucessaoVitalicia
                                            values={values}
                                            estudo={estudo}
                                            report={true}
                                            //jsonConfiguracao={vars.jsonConfiguracao}
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />

                                {paginas(estudo.current.inventario)?.map((item, ind) => (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.composicaoInventario}
                                            conteudo={
                                                <EstudoFormComposicaoInventario
                                                    values={values}
                                                    estudo={estudo}
                                                    report={true}
                                                    indInicial={item.indInicial}
                                                    indFinal={item.indFinal}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    ))
                                }
                                
                                {existeTabelaEvolucaoValorResgate(values) && vars.linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === 'S' && (
                                    <>
                                        {/*!values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira && (
                                            <EstudoReportPage
                                                //key={index}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.carteiraInvestimentos}
                                                conteudo={
                                                    <CarteiraInvestimentosChart
                                                        values={values}
                                                        estudo={estudo}
                                                        report={true}
                                                        popup={false}
                                                        simulacaoFinanceira={true}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        )*/}

                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                        .filter(item => possuiCotacaoSeguroVidaApenasComparacaoPreco(values, item.id, false))
                                        ?.map( (cotacao, indCotacao) => (
                                            <div
                                                key={indCotacao}
                                            >
                                                {values.exibirResumoSeguroVidaCotacao && (
                                                    <EstudoReportPage
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        cabecalho={LABEL.resumoCotacao + ': ' + cotacao.descricao}
                                                        conteudo={
                                                            <EstudoFormResumoSeguroVidaCotacao
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                                utilizarApenasComparacaoPreco={false}
                                                                report={report}
                                                            />
                                                        }
                                                        pagina={obtemPagina(pagina)}
                                                    />
                                                )}

                                                {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                                .filter(item => !item.utilizarApenasComparacaoPreco && item.seguradora === cotacao.id)
                                                ?.map( (item, ind) => (
                                                    
                                                    <div
                                                        key={ind}
                                                    >
                                                        {!values.exibirTabelaEvolucaoCS &&
                                                        !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior,
                                                            HARDCODE.reportLinhasComGraficoGraficoMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoValorResgate
                                                                            values={values}
                                                                            estudo={estudo}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                />
                                                            ))
                                                        )}

                                                        {values.exibirTabelaEvolucaoCS && (
                                                            paginas(item.tabelaEvolucaoValorResgate,
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCS + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCS
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                />
                                                            ))
                                                        )}

                                                        {values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            paginas(item.tabelaEvolucaoValorResgate, 
                                                            HARDCODE.reportLinhasSemGraficoSemTotaisComRodapeLetraMaior)?.map((itemPagina, indPagina) => (
                                                                <EstudoReportPage
                                                                    key={indPagina}
                                                                    variaveisGlobais={variaveisGlobais}
                                                                    values={values}
                                                                    vars={vars}
                                                                    cabecalho={LABEL.tabelaEvolucaoCancelamentoApolice + ': ' + item.nomeFamiliar}
                                                                    conteudo={
                                                                        <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                                            values={values}
                                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                            report={report}
                                                                            indInicial={itemPagina.indInicial}
                                                                            indFinal={itemPagina.indFinal}
                                                                        />
                                                                    }
                                                                    pagina={obtemPagina(pagina)}
                                                                />
                                                            ))
                                                        )}
                                                        
                                                        {(values.exibirTabelaEvolucaoCS ||
                                                        values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <TabelaEvolucaoValorResgateChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                        tabelaEvolucaoValorResgate={false}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                            />
                                                        )}

                                                        {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira &&
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                            />
                                                        )}

                                                        {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira &&
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <EstudoReportPage
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                vars={vars}
                                                                cabecalho={LABEL.analiseInvestimentoVersusSeguroVidaInteira + ': ' +
                                                                    item.nomeFamiliar
                                                                }
                                                                conteudo={
                                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={report}
                                                                    />
                                                                }
                                                                pagina={obtemPagina(pagina)}
                                                            />
                                                        )}
                                                        
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </>
                                )}
                            </>
                        )}

                        {!values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira &&
                        (vars.idConfiguracao  === '1cf12cd8-92d2-4039-9136-eb889b5b22be' || 
                        vars.idConfiguracao  === '2a0c840b-747d-431f-b28c-69e3030f77ad') && (
                            <EstudoReportPage
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                conteudo={
                                    <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        estudo={estudo}
                                        report={true}
                                        popup={false}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        )}

                        {(vars.idConfiguracao === '1cf12cd8-92d2-4039-9136-eb889b5b22be' ||
                        vars.idConfiguracao  === '2a0c840b-747d-431f-b28c-69e3030f77ad') &&
                        !values.naoExibirEvolucaoReservaFinanceira &&
                        paginas(estudo.current.evolucaoReservaFinanceiraReport,
                        HARDCODE.reportLinhasSemGraficoSemTotaisComRodape)?.map((item, ind) => (
                            <EstudoReportPage
                                key={ind}
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.evolucaoReservaFinanceira}
                                conteudo={
                                    <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                                        values={values}
                                        estudo={estudo}
                                        report={true}
                                        popup={false}
                                        indInicial={item.indInicial}
                                        indFinal={item.indFinal}
                                    />
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        ))}

                        {values.exibirComparacaoCenariosRelatorio && (
                            <>
                                {values.exibirComparacaoCenariosRelatorioSemTabelaGrafico
                                    ?
                                        <EstudoReportPage
                                            //key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoCenarios}
                                            conteudo={
                                                <ComparacaoCenariosEstudosChart
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={true}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                    simulacaoFinanceira={true}
                                                    exibirComparacaoCenariosRelatorioSemTabelaGrafico={
                                                        values.exibirComparacaoCenariosRelatorioSemTabelaGrafico
                                                    }
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    :
                                        paginas(calculaMaiorPeriodoGraficoIdadesCenarios(values), HARDCODE.reportLinhasSemGraficoSemTotais,
                                        HARDCODE.reportLinhasComGraficoMenor)?.map((item, ind) => ( // mudança da fonte: 25
                                            <EstudoReportPage
                                                key={ind}
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                vars={vars}
                                                cabecalho={LABEL.comparacaoCenarios}
                                                conteudo={
                                                    <ComparacaoCenariosEstudosChart
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        estudo={estudo}
                                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                        jsonPagina={vars.jsonPagina}
                                                        jsonUsuario={vars.jsonUsuario}
                                                        jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                        report={true}
                                                        comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                        simulacaoFinanceira={true}
                                                        indInicial={item.indInicial}
                                                        indFinal={item.indFinal}
                                                    />
                                                }
                                                pagina={obtemPagina(pagina)}
                                            />
                                        ))
                                }

                                <EstudoFormComparacaoCenariosEstudos
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    estudo={estudo}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    jsonConfiguracao={vars.jsonConfiguracao}
                                    jsonPagina={vars.jsonPagina}
                                    jsonUsuario={vars.jsonUsuario}
                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    report={true}
                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                    simulacaoFinanceira={true}
                                    soCalculo={true}
                                />

                                <EstudoReportPage
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.comparacaoCenarios}
                                    conteudo={
                                        <EstudoFormComparacaoCenariosEstudos
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            jsonPagina={vars.jsonPagina}
                                            jsonUsuario={vars.jsonUsuario}
                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                            report={true}
                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                            simulacaoFinanceira={true}
                                            parte1={
                                                values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                                    ?
                                                        true
                                                    :
                                                        false
                                            }
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />
                                {values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                    ?
                                        <EstudoReportPage
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoCenarios}
                                            conteudo={
                                                <EstudoFormComparacaoCenariosEstudos
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={true}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                                                    simulacaoFinanceira={true}
                                                    parte2={true}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    :
                                        ''
                                }
                            </>
                        )}

                        {values.exibirComparacaoEstudosRelatorio && (
                            <>
                                {paginas(calculaMaiorPeriodoGraficoIdadesEstudos(values), HARDCODE.reportLinhasSemGraficoSemTotais,
                                HARDCODE.reportLinhasComGraficoMenor)?.map((item, ind) => ( // mudança da fonte: 25
                                    <EstudoReportPage
                                        key={ind}
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        vars={vars}
                                        cabecalho={LABEL.comparacaoEstudos}
                                        conteudo={
                                            <ComparacaoCenariosEstudosChart
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                estudo={estudo}
                                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                jsonPagina={vars.jsonPagina}
                                                jsonUsuario={vars.jsonUsuario}
                                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                report={true}
                                                comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                                simulacaoFinanceira={true}
                                                indInicial={item.indInicial}
                                                indFinal={item.indFinal}
                                            />
                                        }
                                        pagina={obtemPagina(pagina)}
                                    />
                                ))}

                                <EstudoFormComparacaoCenariosEstudos
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    estudo={estudo}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    jsonConfiguracao={vars.jsonConfiguracao}
                                    jsonPagina={vars.jsonPagina}
                                    jsonUsuario={vars.jsonUsuario}
                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    report={true}
                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                    simulacaoFinanceira={true}
                                    soCalculo={true}
                                />
                                <EstudoReportPage
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                    cabecalho={LABEL.comparacaoEstudos}
                                    conteudo={
                                        <EstudoFormComparacaoCenariosEstudos
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            jsonPagina={vars.jsonPagina}
                                            jsonUsuario={vars.jsonUsuario}
                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                            report={true}
                                            comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                            simulacaoFinanceira={true}
                                            parte1={
                                                values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                                    ?
                                                        true
                                                    :
                                                        false
                                            }
                                        />
                                    }
                                    pagina={obtemPagina(pagina)}
                                />
                                {values.comparacaoCenariosEstudosItem && values.comparacaoCenariosEstudosItem.length > HARDCODE.comparacaoCenariosEstudosItemMaximoItem1Pagina
                                    ?
                                        <EstudoReportPage
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={LABEL.comparacaoEstudos}
                                            conteudo={
                                                <EstudoFormComparacaoCenariosEstudos
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                    estudo={estudo}
                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                    jsonPagina={vars.jsonPagina}
                                                    jsonUsuario={vars.jsonUsuario}
                                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                    report={true}
                                                    comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                                                    simulacaoFinanceira={true}
                                                    parte2={true}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    :
                                        ''
                                }
                            </>
                        )}

                        {values.exibirConsideracoesFinaisRelatorio && informouConsideracoesFinais(values) && (
                            <>
                                {values.consideracaoFinal?.map((item, ind) => (
                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                        <EstudoReportPage
                                            key={ind}
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            cabecalho={nvl(item.tituloPagina, linhaFormList.labelTabClienteFormListConsideracoesFinais)}
                                            conteudo={
                                                <EstudoFormConsideracoesFinais
                                                    values={values}
                                                    linhaFormList={linhaFormList}
                                                    report={true}
                                                    indPagina={ind}
                                                />
                                            }
                                            pagina={obtemPagina(pagina)}
                                        />
                                    )
                                ))}
                            </>
                        )}

                        <EstudoReportPage
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            cabecalho={LABEL.disclaimer}
                            conteudo={
                                <EstudoReportDisclaimer
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            }
                            pagina={obtemPagina(pagina)}
                        />
                    </>
                }
            />
        </>
    )
}

export default EstudoReportPrimeiraReuniaoCliente